import classes from './LocalityFields.module.css';

// @ai-generated 2026-07-17T21:45:00+00:00 by dimitri.driediger@synqony.com using Claude Fable 5

/**
 * Invisible aria-live region: announces lookup results, adoptions and conflicts to screen readers
 * without putting a second copy of the text on the screen.
 */
export function LiveAnnouncer({ message }: { message: string }) {
    return (
        <div aria-live="polite" className={classes.visuallyHidden}>
            {message}
        </div>
    );
}
